<div class="relative min-h-screen flex flex-col">
    <!--Navbar-->
    <app-navbar></app-navbar>

    <!-- Top Banner Section Start -->
    <div class="flex-grow">
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[500px] banner-wrapper">
                        <img src="/assets/images/banners/booking-details-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">Booking Details</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->

        <!--Main container starts-->
        <div class="container mx-auto mt-3 mb-10">
            <!-- Mat Spinner  -->
            <ngx-spinner bdColor="rgba(256, 256, 256, 1)" size="default" color="#6eabc6" type="ball-spin-fade"
                [fullScreen]="true">
                <p style="color: black"> Please wait... </p>
            </ngx-spinner>
            <div class="custom-margin mt-5 box">
                <!-- Top section -->
                <div class="text-center border-b-2 border-slate-200 dark:border-darkmode-400 sm:text-left">
                    <div class="px-5 py-10 sm:px-20 sm:py-15">
                        <div class="text-3xl font-semibold text-primary">Medical Appointment Details</div>

                        <div class="mt-1">Date: {{ booking_details?.created_at | date:'MMM dd, yyyy' }}</div>
                    </div>
                    <div class="flex flex-col px-5 pt-10 pb-10 lg:flex-row sm:px-20 sm:pb-20">
                        <div class="text-left">
                            <div class="text-base text-slate-500 font-semibold"> Details</div>
                            <div class="mt-2 text-lg font-bold text-[#4c61ac]"> Name: <span
                                    class="text-black">{{booking_details?.name}}</span> </div>
                            <div class="mt-1">Phone: {{booking_details?.phone}}</div>
                            <div class="mt-3"></div>
                            <div class="text-base  font-bold text-left">Patient Name :&nbsp;<span
                                class="font-medium text-[#4c61ac]">{{booking_details?.patient[0]?.name}}</span></div>
                            <div class="text-base  font-bold text-left">Gender :&nbsp;<span
                                class="font-medium text-[#4c61ac]">{{booking_details?.patient[0]?.gender}}</span></div>
                            <div class="text-base  font-bold text-left">Date of Birth :&nbsp;<span
                                class="font-medium text-[#4c61ac]">{{booking_details?.patient[0]?.dob}}</span></div>
                        </div>
                        <div class="mt-10 lg:text-right lg:mt-0 lg:ml-auto justify-items-start">
                            <div class="text-base  font-bold text-left">Booking Number :&nbsp;<span
                                    class="font-medium text-[#4c61ac]">{{booking_details?.booking_no}}</span></div>
                                    
                            <div class="mt-2 text-sm font-semibold text-primary text-left">Doctor :&nbsp;
                                <span>{{booking_details?.entity.name}}</span>
                            <div class="mt-2 text-sm font-semibold text-primary text-left">Hospital Branch :&nbsp;
                                <span>{{booking_details?.branch.name}}</span>
                            </div>

                            <div class="mt-2 text-sm font-semibold text-primary text-left">Slot On
                                :&nbsp;{{booking_details?.slot.start_time |
                                date:'dd/MM/yyyy'}} &nbsp; {{booking_details?.slot.start_time | date: 'h:mm
                                a'}}-{{booking_details?.slot.end_time | date: 'h:mm a'}}</div>
                            <div class="mt-1"></div>
                            <div class="mt-4 text-left"
                                *ngIf="!isDatePassed && isSuccess && booking_details?.payment && booking_details.payment?.amount">
                                <button mat-stroked-button color="primary"
                                    (click)="rescheduleEntireBooking()">Re-schedule</button>
                                <button mat-flat-button color="primary" class="ml-5"
                                    (click)="cancelEntireBooking()">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!booking_details?.payment && !isDatePassed"
                    class="flex px-5 py-10 sm:px-20 sm:pb-20 flex-col items-center justify-around">
                    <p class="font-semibold  text-red-800 text-[1.4em]">
                        You didn't complete the payment. Please check your email to complete the payment.
                    </p>
                </div>


                <!--Message to display if date is passed-->
                <div *ngIf="isDatePassed" class="flex px-5 pt-3 sm:px-20 flex-col items-center justify-around">
                    <p class="text-[1.2em] font-semibold  text-red-800">
                        We're sorry, but it seems that the appointment date you have selected has already passed. Please
                        choose a new appointment date. If you need further assistance, please don't hesitate to contact
                        us..!
                    </p>
                </div>


                <div class="flex items-center p-[0.5em] justify-center flex-wrap booking-details-wrapper">
                    <div
                        class="flex flex-col sm:flex-row items-center w-[650px] p-[0.5em] h-[275px] booking-details-content">
                        <div
                            class="flex items-center flex-wrap p-[1em] w-[100%] sm:w-[40%] h-[100%] justify-center lg:rounded-l-3xl heading-sec relative">
                            <img src="/assets/images/payment-card-bg.png" alt=""
                                class="lg:rounded-l-3xl object-cover sm:object-fill payment-bg">
                            <div class="w-[40px] h-[35px] mr-2 img-container">
                                <img src="/assets/images/main-icon.png" alt="" class="w-[100%] h-[100%] object-contain">
                            </div>
                            <div class="heading">
                                <h2 class="text-[1.1em] font-medium text-white my-2">Booking Number</h2>
                                <h4 class="text-[1.3em] font-medium text-white my-2">
                                    <span>{{booking_details?.booking_no}}</span>
                                </h4>
                            </div>
                        </div>
                        <div
                            class="flex justify-between items-center w-[100%] sm:w-[60%] h-[100%] p-[1em] bg-[#f8fafb] relative">
                            <div class="icon-line-container">
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/booking-icon.png" alt="">
                                        </span>
                                        <span>Booked On</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{ booking_details?.created_at |
                                        date:'MMM
                                        dd, yyyy' }}</p>
                                </div>
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/doctor-icon.png" alt="">
                                        </span>
                                        <span>Doctor</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{booking_details?.slot.entity}}</p>
                                </div>
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/slot-icon.png" alt="">
                                        </span>
                                        <span>Slot On</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold mb-0 ml-[2.3em]">
                                        {{booking_details?.slot.start_time
                                        |
                                        date:'dd-MMMM-yyyy'}}</p>
                                </div>
                                <div class="vertical-line"></div>
                            </div>
                            <div class="icon-second-line-container">
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/email-icon.png" alt="">
                                        </span>
                                        <span>Email</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{booking_details?.email}}</p>
                                </div>
                                <div>
                                    <div class="text-xs font-normal text-[#6eabc6]">
                                        <span class="icon-container">
                                            <img src="/assets/images/phone-icon.png" alt="">
                                        </span>
                                        <span>Phone</span>
                                    </div>
                                    <p class="text-[0.75em] font-bold ml-[2.3em]">{{booking_details?.phone}}</p>
                                </div>
                                <div class="second-vertical-line"></div>
                            </div>
                        </div>
                    </div>
                    <div class="booking-payment-details">
                        <div class="w-[350px] mx-auto my-5 pb-[3.5em] booking-list-card relative">
                            <div class="image-wrapper">
                                <img src="/assets/images/card-bg.png" alt="">
                            </div>
                            <div class=" p-[1.5em] card-bg rounded-t-3xl">
                                <h4 class="text-[1.5em] font-medium text-white">Payment Details</h4>
                            </div>
                            <h2 class="text-black text-base my-0 font-medium px-[1.5em] py-[1em]">
                                {{booking_details?.booking_no}}
                            </h2>
                            <div class="flex justify-between px-[1.5em]">
                                <div class="text-left date-sec">
                                    <span class="text-[0.75rem] text-gray-400">Date</span>
                                    <p class="text-[0.75em] font-medium m-0 my-2 py-[0.5em]">{{
                                        booking_details?.created_at | date:'MMM
                                        dd, yyyy' }}</p>
                                </div>
                                <div class="text-left payment-method">
                                    <span class="text-[0.75rem] text-gray-400">Payment</span>
                                    <p class="text-[0.75em] font-medium m-0 my-2 py-[0.5em]">{{booking_details?.payment?
                                        booking_details?.payment.method.name:"N/A"}}</p>
                                </div>
                                <div class="status-sec">
                                    <div class="text-left sm:ml-auto" *ngIf="booking_details?.payment">
                                        <span class="text-[0.75rem] text-gray-400">Payment Status</span>
                                        <p
                                            class="text-[0.75em] font-medium text-[#677db9] bg-[#f0f2f8] p-[0.5em] rounded m-0 my-2">
                                            Completed</p>
                                    </div>
                                    <div class="text-left sm:ml-auto" *ngIf="!booking_details?.payment">
                                        <span class="text-[0.75rem]">Payment Status</span>
                                        <p
                                            class="text-[0.75em] font-medium text-[#677db9] bg-[#f0f2f8] p-[0.5em] rounded m-0 my-2">
                                            Failed / Pending</p>
                                    </div>
                                </div>
                            </div>
                            <div class="px-[1.5em] address-sec">
                                <span class="text-[0.75rem] text-gray-400">Address</span>
                                <p class="text-[0.75em] font-medium m-0 my-2 py-[0.5em]">Medease, Street Road,
                                    California</p>
                            </div>
                            <div class="border-t border-gray-300 mx-[1.5em]"></div>
                            <div class="px-[1.5em] payment-details my-3">
                                <div class="flex items-center justify-between flex-wrap">
                                    <span class="text-black text-base font-medium">Total Advance Amount</span>
                                    <p class="text-black text-sm font-medium m-0 my-2 py-[0.5em]">
                                        {{booking_details?.payment && booking_details?.payment.amount !== null &&
                                        booking_details?.payment.amount !== undefined ? booking_details?.payment.amount
                                        :
                                        "N/A"}}
                                    </p>
                                </div>
                            </div>
                            <div class="border-t border-gray-300 mx-[1.5em]"></div>
                            <div class="px-[1.5em] text-center pb-[1em] text">
                                <p class="text-[1em] font-normal text-black">Taxes Included</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex flex-col-reverse px-5 pb-10 sm:px-20 sm:pb-10 justify-center sm:justify-start sm:flex-row content-center items-center">
                    <p class="text-xs">For enquiries contact: 0471 294 1938 | 1950 | 1312 between 8.00 am and 5.30 pm,
                        Monday to Saturday.</p>
                </div>

            </div>
        </div>

    </div>

    <!-- Footer  -->
    <app-message></app-message>
    <app-footer></app-footer>
</div>